import React from 'react';
import { Modal } from '../../common/components/Modal';
import styles from './AlertModal.module.scss';

type AlertType = 'success' | 'error' | 'warning' | 'info';

interface AlertModalProps {
    isOpen: boolean;
    onClose: () => void;
    message: string;
    type?: AlertType;
}

const AlertModal: React.FC<AlertModalProps> = ({ isOpen, onClose, message, type = 'info' }) => {
    // Determine header title based on type
    const getHeaderTitle = (): string => {
        switch (type) {
            case 'success':
                return 'Success';
            case 'error':
                return 'Error';
            case 'warning':
                return 'Warning';
            case 'info':
            default:
                return 'Information';
        }
    };

    // Determine icon based on type
    const getIconContent = (): string => {
        switch (type) {
            case 'success':
                return '✓';
            case 'error':
                return '✕';
            case 'warning':
                return '⚠';
            case 'info':
            default:
                return 'ℹ';
        }
    };

    const headerContent = (
        <>
            <span className={styles.alertModalIcon}>{getIconContent()}</span>
            <h3 className={styles.alertModalTitle}>{getHeaderTitle()}</h3>
        </>
    );

    const footerContent = (
        <button
            className={`${styles.alertModalButton} ${styles[`alertButton${type.charAt(0).toUpperCase() + type.slice(1)}`]}`}
            onClick={onClose}
        >
            OK
        </button>
    );

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size='sm'
            showCloseButton={false}
            closeOnOverlayClick={true}
            closeOnEscape={true}
            showDefaultFooter={false}
            header={headerContent}
            headerClassName={`${styles.alertModalHeader} ${styles[`alertModalHeader${type.charAt(0).toUpperCase() + type.slice(1)}`]}`}
            footer={footerContent}
            footerClassName={styles.alertModalFooter}
        >
            {message}
        </Modal>
    );
};

export default AlertModal;
